<template>
  <div
    class="menu-list-box"
    :style="'right:' + (isMenuShow ? '0%' : '-45%') + ';'"
  >
    <div class="menu-list">
      <div
        @click.stop
        class="list"
        v-for="(n, index) in menuList"
        :class="$attrs.pageIndex === index ? 'activated' : ''"
        @click="changePageIndex(index)"
        :key="index"
      >
        {{ n }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMenuShow: false,
      menuList: [
        "ホーム",
        "機能",
        "ダウンロード",
        "支払",
        "サービス",
        "キャンペーン",
      ],
    };
  },
  methods: {
    init() {
      this.isMenuShow = true;
    },
    changePageIndex(index) {
      if (index === 5) {
        this.$router.push("/activityPage");
        return false;
      }
      this.$emit("changePage", index);
    },
    close() {
      this.isMenuShow = false;
    },
  },
};
</script>
<style scoped>
.menu-list-box {
  position: absolute;
  width: 45%;
  top: 0;
  right: -45%;
  background: #222;
  height: 100%;
  transition: all 0.5s;
}

.menu-list {
  box-sizing: border-box;
  padding-top: 4rem;
}

.list {
  height: 2rem;
  font-weight: normal;
  font-size: 0.8rem;
  margin: 2rem 0;
  box-sizing: border-box;
  padding-left: 1.5rem;
  transition: all 0.5s;
}

.list.activated {
  color: #dbbf2a;
}
</style>



// WEBPACK FOOTER //
// src/components/pe-home/modules/menu-list.vue